import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import { Button, ButtonColorType } from "@/ui-components/commonComponents/Button/Button";

import style from "./style.module.css";

export function ConvertToTestSpecificModal({
  isOpen,
  isLoading = false,
  scaleAbbr,
  onCancel,
  onConfirm,
}: {
  isOpen: boolean;
  isLoading?: boolean;
  scaleAbbr: string;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <BasicModal
      autoHeight
      isModalOpen={isOpen}
      handleCancel={onCancel}
      footer={
        <div className={style.modalActions}>
          <Button colorType={ButtonColorType.light} onClick={onCancel}>
            cancel
          </Button>
          <Button isLoading={isLoading} onClick={onConfirm}>
            confirm
          </Button>
        </div>
      }
    >
      <div className={style.modalContent}>
        <h2 className={style.modalTitle}>Convert {scaleAbbr} to Test Specific</h2>
        <p className={style.modalDescription}>
          This scale is currently shared with other tests. Are you sure you want to convert it to be specific to this
          test only? Remember this action cannot be undone.
        </p>
      </div>
    </BasicModal>
  );
}
